import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext({ ids: [], toggle: () => {}, has: () => false, compare: [], toggleCompare: () => {}, clearCompare: () => {} });
const KEY = "safarshala_wishlist";
const CKEY = "safarshala_compare";
const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || "[]"); } catch { return []; } };

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => read(KEY));
  const [compare, setCompare] = useState(() => read(CKEY));
  useEffect(() => localStorage.setItem(KEY, JSON.stringify(ids)), [ids]);
  useEffect(() => localStorage.setItem(CKEY, JSON.stringify(compare)), [compare]);
  const toggle = (id) => setIds((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const toggleCompare = (id) => setCompare((s) => (s.includes(id) ? s.filter((x) => x !== id) : s.length >= 3 ? s : [...s, id]));
  return <Ctx.Provider value={{ ids, toggle, has: (id) => ids.includes(id), compare, toggleCompare, clearCompare: () => setCompare([]) }}>{children}</Ctx.Provider>;
}

export const useWishlist = () => useContext(Ctx);
